"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/no-danger */

/* eslint-disable import/no-extraneous-dependencies */
var WDHImage = function WDHImage(_ref) {
  var image = _ref.image,
      imageHTML = _ref.imageHTML,
      className = _ref.className;
  var html = imageHTML || image && image.outerHTML || '<img />';
  return _react["default"].createElement("div", {
    className: className,
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

WDHImage.propTypes = {
  image: _propTypes["default"].instanceOf(HTMLImageElement),
  imageHTML: _propTypes["default"].string,
  className: _propTypes["default"].string
};
WDHImage.defaultProps = {
  image: null,
  imageHTML: null,
  className: ''
};
var _default = WDHImage;
exports["default"] = _default;